import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'

export const AccountBreadCrumbs = ({ ...props }: React.ComponentProps<typeof Breadcrumbs>) => {
  const { t } = useTranslation()
  const account = useSelector(state => state.account.detail)
  const invoice = useSelector(state => state.workorder.invoice.Workorder)
  const detailText = (uuid: string, value = '') => (uuid === 'new' ? t('global.new') : t('global.edit_val', { value }))

  return (
    <Breadcrumbs {...props}>
      <Crumb data-testid='crumb-accounts' key='crumb-accounts' path='/accounts' text={t('Account.PageTitle')} />
      <Crumb
        data-testid='crumb-accounts-uuid'
        key='crumb-accounts-uuid'
        path='/accounts/:uuid'
        text={params =>
          detailText(params.uuid, account.CompanyName || `${account.FirstName || ''} ${account.NamePrefix || ''} ${account.Name}`)
        }
      />
      <Crumb
        data-testid='crumb-history-invoices-view'
        key='crumb-history-invoices-view'
        path='/accounts/:uuid/invoices/:uuid'
        text={`${t('invoice.invoice')} ${invoice.InvoiceNumber}`}
      />
      <Crumb
        data-testid='crumb-accounts-view-link-vehicle'
        key='crumb-accounts-view-link-vehicle'
        path='/accounts/:uuid/link-vehicle'
        text={t('account.link_vehicle')}
      />
    </Breadcrumbs>
  )
}

export default AccountBreadCrumbs
